import { useEffect, useState } from "react";
import withLoader from "../../../components/layouts/WithLoader";
import WarehouseService from "../../../services/WarehouseService";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import CarteCadeauService from "../../../services/MarketingService/CarteCadeauService";
import { Alert, Snackbar } from "@mui/material";
import DataTableListCarteCadeau from "./DataTableListCarteCadeau";

const styles = {
  container: (base) => ({
    ...base,
    flex: 1,
  }),
};
const CartesCadeau = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();
  const animatedComponents = makeAnimated();

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [allWarehouseSource, setAllWarehouseSource] = useState([{}]);
  const [warehousesSource, setWarehousesSource] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [warehouseSourceId, setWarehouseSourceId] = useState(0);
  const [warehouseSelectPlaceHolder, setWarehouseSelectPlaceHolder] =
    useState("Choisir...");

  const [listCarteCadeaux, setListCarteCadeaux] = useState([]);
  const [showTable, setShowTable] = useState(false);

  useEffect(() => {
    WarehouseService.getAllRealWarehouse(getCurrentUserId(), 0)
      .then((response) => {
        if (response.data.success) {
          setWarehousesSource(response.data.success);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : pas de dépôt");
        }
      })
      .catch((e) => {
        console.log("error in getAllRealWarehouse", e);
      });
  }, []);

  useEffect(() => {
    warehousesSource &&
      warehousesSource.map((element) => {
        let exist = false;
        if (allWarehouseSource.length !== 0) {
          for (let index = 0; index < allWarehouseSource.length; index++) {
            if (allWarehouseSource[index].value === element?.id) {
              exist = true;
              break;
            }
          }
        }
        if (element?.id !== undefined && exist === false) {
          setAllWarehouseSource((oldArray) => [
            ...oldArray,
            { value: element.id, label: element.name },
          ]);
        }
        //here
      });
  }, [warehousesSource]);

  const onAddCarteCadeauHandler = () => {
    navigate(`/addCarteCadeau`);
  };
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };
  const onChangeSelectedWarehouseSource = (selectedOptionn) => {
    setSelectedOption();
    setWarehouseSourceId(selectedOptionn.value);
    setWarehouseSelectPlaceHolder(selectedOptionn.label);
  };

  const onGetCarteCadeauByWarehouse = () => {
    startLoading();
    CarteCadeauService.getAllCarteCadeau(
      getCurrentUserId(),
      warehouseSourceId,
      1
    )
      .then((response) => {
        if (response.data["success"]) {
          setListCarteCadeaux(response.data["success"]);
          setShowTable(true);
        }
      })
      .catch((e) => {
        console.log("error", e);
      })
      .finally(() => {
        stopLoading();
      });
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card  mt-3">
                <div class="card-body">
                  <h5 class="card-title">Les Cartes cadeaux</h5>
                  <button
                    class="btn btn-dark float-right"
                    data-toggle="modal"
                    data-target="#add-brand"
                    onClick={onAddCarteCadeauHandler}
                  >
                    <i class="fas fa-plus"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="content ">
        <div className="container-fluid">
          <div class="card card-dark">
            <div className="card-header">
              <h5 className="card-title">Choisir le dépôt </h5>
            </div>
            <div class="card-body">
              <div class="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <div className="input-group">
                      <div
                        className="input-group-prepend"
                        style={{ width: "90%" }}
                      >
                        <Select
                          styles={styles}
                          closeMenuOnSelect={true}
                          components={animatedComponents}
                          defaultValue={selectedOption}
                          onChange={onChangeSelectedWarehouseSource}
                          options={allWarehouseSource}
                          placeholder={warehouseSelectPlaceHolder}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-footer">
              <div className="col-sm-12  text-center">
                <button
                  className="btn btn-dark float-right"
                  onClick={onGetCarteCadeauByWarehouse}
                >
                  Valider le choix
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

     
            {showTable && (
                  <DataTableListCarteCadeau listCarteCadeaux={listCarteCadeaux} />
                )}
        

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(CartesCadeau);
